import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from './useAuth';

export function useContact(contactId) {
  const { currentUser } = useAuth();
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser || !contactId) {
      setContact(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    const contactRef = doc(db, 'contacts', contactId);

    const unsubscribe = onSnapshot(
      contactRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const contactData = {
            id: docSnap.id,
            ...docSnap.data()
          };

          // Verify ownership
          if (contactData.ownerId === currentUser.uid) {
            setContact(contactData);
            setError(null);
          } else {
            setContact(null);
            setError('Access denied');
          }
        } else {
          setContact(null);
          setError('Contact not found');
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching contact:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [currentUser, contactId]);

  return { contact, loading, error };
}
